export default __webpack_public_path__ + "static/fp-full-logo-white-af9561fe429ca3b5a2354cfc6b6de484.svg";